module.exports = __webpack_public_path__ + "img/icon-user.f2a90bb9.svg";